<template>
  <BaseStyle :model="model" class="content-base">
    <div
      v-for="item in model.listItems"
      :key="item"
      class="w-full flex space-x-1"
    >
      <div class="flex-shrink-0" v-html="model.markerText" />
      <div
        class="flex-grow"
        v-html="item"
      />
    </div>
  </BaseStyle>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import { ContentItemizedListModel } from '@/models/content_itemized_list_model';

import BaseStyle from './BaseStyle.vue';
export default defineComponent({
  name: 'ContentItemizedList',
  components: {
    BaseStyle,
  },
  props: {

    /**
     * Model
     */
    model: {
      type: Object as PropType<ContentItemizedListModel>,
      required: true,
    },
  },
});
</script>
